var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0216 3.15259C9.43581 3.15259 6.52164 6.06675 6.52164 9.65259V12.7834C6.52164 13.4443 6.23997 14.4518 5.90414 15.0151L4.65831 17.0843C3.88914 18.3626 4.41997 19.7818 5.82831 20.2584C10.4975 21.8184 15.535 21.8184 20.2041 20.2584C21.515 19.8251 22.0891 18.2759 21.3741 17.0843L20.1283 15.0151C19.8033 14.4518 19.5216 13.4443 19.5216 12.7834V9.65259C19.5216 6.07759 16.5966 3.15259 13.0216 3.15259Z",
    stroke: "#9B9B9B",
    strokeWidth: 1.625,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0259 3.46656C14.6901 3.36906 14.3434 3.29323 13.9859 3.2499C12.9459 3.1199 11.9492 3.19573 11.0176 3.46656C11.3317 2.6649 12.1117 2.10156 13.0217 2.10156C13.9317 2.10156 14.7117 2.6649 15.0259 3.46656Z",
    stroke: "#9B9B9B",
    strokeWidth: 1.625,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2717 20.6484C16.2717 22.4359 14.8092 23.8984 13.0217 23.8984C12.1334 23.8984 11.3101 23.5301 10.7251 22.9451C10.1401 22.3601 9.77173 21.5368 9.77173 20.6484",
    stroke: "#9B9B9B",
    strokeWidth: 1.625,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.10eec5048ab3e7dea49c77ef6d9db453.svg";
export { ForwardRef as ReactComponent };